import { atom } from 'jotai';

export const entAnalyticsUpgradeModalOpenAtom = atom(false);
